const prefix = "EXCEPTION_LOG_";

export const CONNECTIVITY_FAILED = prefix + "CONNECTIVITY_FAILED";
export const CONNECTIVITY_STARTED = prefix + "CONNECTIVITY_STARTED";
export const CONNECTIVITY_SUCCEEDED = prefix + "CONNECTIVITY_SUCCEEDED";
export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const STATS_BY_MONTH_FAILED = prefix + "STATS_BY_MONTH_FAILED";
export const STATS_BY_MONTH_STARTED = prefix + "STATS_BY_MONTH_STARTED";
export const STATS_BY_MONTH_SUCCEEDED = prefix + "STATS_BY_MONTH_SUCCEEDED";
export const STATS_FOR_WEEK_FAILED = prefix + "STATS_FOR_WEEK_FAILED";
export const STATS_FOR_WEEK_STARTED = prefix + "STATS_FOR_WEEK_STARTED";
export const STATS_FOR_WEEK_SUCCEEDED = prefix + "STATS_FOR_WEEK_SUCCEEDED";
export const STATS_TOGGLE_ACTIVE = prefix + "STATS_TOGGLE_ACTIVE";
export const THROW_STARTED = prefix + "THROW_STARTED";
export const THROW_SUCCEEDED = prefix + "THROW_SUCCEEDED";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
